import type { ReactNode } from 'react';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { plataforma } from '@/platform';

/**
 * Escolhe o roteador conforme o alvo.
 *
 * O desktop carrega o renderer com `loadFile` (`file://…/dist/index.html`),
 * onde um caminho como `/clientes` apontaria para a raiz do disco e a
 * navegação quebraria — por isso hash. O web usa caminho normal, que dá
 * URL limpa e compartilhável.
 *
 * A escolha vem de `plataforma.capacidades.tipoRoteador` para ficar num
 * lugar só, junto das outras diferenças entre os alvos.
 */
export function Roteador({ children }: { children: ReactNode }) {
  if (plataforma.capacidades.tipoRoteador === 'hash') {
    return <HashRouter>{children}</HashRouter>;
  }
  return <BrowserRouter>{children}</BrowserRouter>;
}
